/**
 * Garantiza en tiempo de compilacion que un `switch` sobre una union discriminada
 * cubre todos los casos. Si aparece un caso nuevo, el compilador marca el error.
 */
export function assertNever(value: never, message = 'Caso no contemplado'): never {
  throw new Error(`${message}: ${JSON.stringify(value)}`);
}
